import { Banner, Layout } from '@shopify/polaris';

export const SuccessBanner = () => (
  <Layout.Section>
    <Banner status="success">
      <p>Success! Your Telegram is now connected.</p>
    </Banner>
  </Layout.Section>
);
